export const savedGiftSchema = {
    title: "",
    description: "",
    price: "",
    image_url: "",
    link: "",
    source: "",
    status: "saved",
    recipient_name: "",
    occasion: "",
  };
  
  export const createSavedGift = (gift, formData = {}) => ({
    title: gift.title || "",
    description: gift.description || gift.reason || gift.match_reason || "",
    price: gift.price || formData.budget || "",
    image_url: gift.image_url || "",
    link: gift.link || gift.url || "",
    source: gift.source || formData.store || "Amazon",
    status: gift.status || "saved",
    recipient_name:
      formData.recipient_name ||
      formData.recipientName ||
      formData.relationship ||
      "",
    occasion: formData.occasion || "",
  });